import { copyListFormStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsCopyListForm";
import { css } from "styled-components";

copyListFormStyles.cancelButton = {
    variant: "secondary",
    css: css`
        margin-right: 25px;
    `,
};
